import ReactECharts from "echarts-for-react";

// 12 months list
const allMonths = [
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
  "Jan",
  "Feb",
  "Mar",
];

const SingleBarLineChart = ({
  data = [],
  xKey,
  barKey,
  lineKey,
  barLabel = "Bar",
  lineLabel = "Line",
  height = 300,
}) => {
  // Normalize to ensure all 12 months are present
  const normalizedData = allMonths.map((month) => {
    const found = data.find((item) => item[xKey] === month);
    return found
      ? { ...found, isMissing: false }
      : { [xKey]: month, [barKey]: 0, [lineKey]: null, isMissing: true };
  });

  const xAxisData = normalizedData.map((item) => item[xKey]);

  const barData = normalizedData.map((item) => ({
    value: item[barKey],
    itemStyle: {
      color: item.isMissing ? "#E0E0E0" : "#73C0DE",
      borderRadius: [10, 10, 0, 0],
    },
    label: {
      show: !item.isMissing,
      position: "inside",
      rotate: 90,
      color: "#000",
      fontSize: 12,
    },
    tooltip: item.isMissing ? { show: false } : {},
  }));

  const lineData = normalizedData.map((item) => item[lineKey]);

  const options = {
    tooltip: {
      trigger: "axis",
      axisPointer: { type: "none" }, // Remove axis pointer
      position: function (point, params, dom, rect, size) {
        // Always show tooltip on the right
        return [point[0] + 20, point[1]];
      },
      formatter: (params) => {
        const barItem = params.find((p) => p.seriesType === "bar");
        if (barItem && barItem.data?.tooltip?.show === false) {
          return "";
        }
        return params
          .map(
            (p) =>
              `${p.marker} ${p.seriesName}: <b>${
                p.value == null ? "N/A" : p.value
              }</b>`
          )
          .join("<br/>");
      },
    },
    legend: {
      data: [barLabel, lineLabel],
      bottom: 0, // position at the bottom
      left: "center", // center horizontally
      orient: "horizontal", // horizontal layout
      textStyle: { fontSize: 11 },
    },

    grid: {
      top: "10%",
      left: "-3%",
      right: "3%",
      bottom: "21%",
      containLabel: true,
    },
    xAxis: {
      type: "category",
      data: xAxisData,
    },
    yAxis: {
      type: "value",
      show: false, // hide y-axis labels
      splitLine: { show: false }, // remove grid lines
    },
    series: [
      {
        name: barLabel,
        type: "bar",
        data: barData,
        barWidth: "20",
        barGap: "40%",
        barMinHeight: 100,
      },
      {
        name: lineLabel,
        type: "line",
        data: lineData,
        smooth: true,
        lineStyle: { color: "#5470C6" },
        symbol: "circle",
        symbolSize: 8,
      },
    ],
  };

  return <ReactECharts option={options} style={{ height }} />;
};

export default SingleBarLineChart;
